import type { ComponentProps, ReactNode } from "react";
import { ExternalLink } from "lucide-react";

import { cn } from "@/lib/utils";

export interface ExternalLinkTextProps extends ComponentProps<"a"> {
  children: ReactNode;
  truncate?: boolean;
}

export function ExternalLinkText({
  children,
  className,
  truncate = false,
  target = "_blank",
  rel = "noreferrer",
  ...props
}: ExternalLinkTextProps) {
  return (
    <a
      target={target}
      rel={rel}
      className={cn(
        "inline-flex min-w-0 items-center gap-1 text-xs font-medium text-muted-foreground hover:text-foreground",
        className,
      )}
      {...props}
    >
      <span className={cn(truncate && "truncate")}>{children}</span>
      <ExternalLink className="h-3 w-3 shrink-0" aria-hidden="true" />
    </a>
  );
}
